import {
  ChangeDetectionStrategy,
  Component,
  input,
  Input,
  output,
} from '@angular/core';
import { FluorescenceChannel } from 'src/app/_models/fluorescence-channel';
import { MatIconButtonComponent } from '../../buttons/mat-icon-button/mat-icon-button.component';

@Component({
  selector: 'app-fluorescence-channel-card',
  imports: [MatIconButtonComponent],
  templateUrl: './fluorescence-channel-card.component.html',
  styleUrl: './fluorescence-channel-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FluorescenceChannelCardComponent {
  /** The fluorescence channel to be displayed */
  channel = input<FluorescenceChannel>();

    /** Display button */
  displayButton = input<boolean>(false);

  /** Event emitted when the button is clicked */
  buttonClicked = output<number>();

  isDisabled = input<boolean>(false);

  /** Handles the button click event and emits the buttonClicked event */
  clickButton = (id: number): void => {
    this.buttonClicked.emit(id);
  };
}
